<script setup lang="ts">
import ChartVue from './components/Chart.vue';
</script>
<template>
  <ChartVue />
</template>
